import script from "./PptxViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PptxViewer.vue?vue&type=script&setup=true&lang=js"

import "./PptxViewer.vue?vue&type=style&index=0&id=3f29895c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f29895c"]])

export default __exports__